import { actions } from '../../../state/status';
import AlertTranslation from '../../elements/AlertTranslation';
import { connect } from 'react-redux';
import { actions as authactions } from '../../../state/auth';
import { actions as assessmentactions } from '../../../state/assessment';
import { actions as statusactions } from '../../../state/status';
import { getStore, getPersistor } from '../../../index.js';
import { push } from 'connected-react-router';

const mapStateToProps = (state, ownProps) => ({

 // locale: ownProps.match.params.locale,
  isOpen: state.shift.status.error
});

// const mapDispatchToProps = dispatch => ({
//   onClose: () => dispatch(actions.resetStatus())
// });


const mapDispatchToProps = (dispatch, ownProps) => 
  //const { locale } = ownProps.match.params;

   ({
      onClose: value => {
        //assessmentactions.resetAssessmentStore();
      //  dispatch(push(`/en-CA/snowflake`));
      // dispatch(assessmentactions.resetAssessmentStore());
     dispatch(authactions.logout())
     .then(dispatch(()=>{
       localStorage.clear();
       sessionStorage.clear();
       assessmentactions.resetAssessmentStore();
       statusactions.resetStatus();
       window.location.reload();
     }));
    }
  })
;

const AlertTranslationComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(AlertTranslation);

export default AlertTranslationComponent;



// WEBPACK FOOTER //
// ./src/components/container/AlertTranslation/index.js